<div
    class="flex justify-content-center align-items-center py-2"
    style="background-color: #000"
>
    <img src="assets/images/LincSell-White_Logo.svg" alt="" />
</div>
<!-- Toast Messages -->
<p-toast position="bottom-center"></p-toast>

<!-- Custom Loading Spinner Overlay -->
<div *ngIf="isLoadingStepStatus" class="loading-overlay">
    <div class="loading-spinner-container">
        <div class="spinner-circle">
            <i class="pi pi-spin pi-spinner"></i>
        </div>
        <p class="loading-text">Processing...</p>
    </div>
</div>

<div class="widget-wrapper font-family-system">
    <!-- LOGO -->

    <div
        class="onboarding-card"
        [style.opacity]="isLoadingStepStatus ? 0.5 : 1"
        [style.pointerEvents]="isLoadingStepStatus ? 'none' : 'auto'"
    >
        <!-- MAIN CONTENT (Hidden on Success) -->
        <div *ngIf="!isSuccess" class="fade-in">
            <!-- HEADER -->
            <div class="card-header">
                <div class="header-row">
                    <h3 class="header-title">Setup Guide</h3>
                    <span class="header-count"
                        >{{ completedSteps.size }} of 3 Completed</span
                    >
                </div>
                <!-- PrimeNG Progress Bar -->
                <p-progressBar
                    [value]="progressPercent"
                    [showValue]="false"
                    styleClass="custom-progress"
                ></p-progressBar>
            </div>
            <!-- PRIMENG ACCORDION -->
            <p-accordion
                *ngIf="isInitializationComplete"
                [(activeIndex)]="activeIndex"
                styleClass="custom-accordion"
                (onOpen)="onAccordionOpen($event)"
                (onClose)="onAccordionClose($event)"
            >
                <!-- STEP 1: Business Details -->
                <p-accordionTab [disabled]="false" *ngIf="showBusinessDetails">
                    <ng-template pTemplate="header">
                        <div class="step-header-content">
                            <div class="step-left">
                                <div
                                    class="icon-box"
                                    [class.completed]="isStepCompleted(1)"
                                >
                                    <!-- <span *ngIf="!isStepCompleted(1)">1</span> -->
                                    <i
                                        *ngIf="isStepCompleted(1)"
                                        class="pi pi-check"
                                        style="
                                            font-size: 12px;
                                            font-weight: bold;
                                        "
                                    ></i>
                                </div>
                                <span
                                    class="step-text"
                                    [class.text-completed]="isStepCompleted(1)"
                                    >Tell us about your business</span
                                >
                            </div>
                        </div>
                    </ng-template>
                    <div class="step-content-inner">
                        <p class="helper-text">
                            Tell us about your business and where it's located.
                        </p>

                        <form [formGroup]="businessDetailsForm">
                            <!-- Business Name - Only show if not pre-filled -->
                            <div
                                class="form-group"
                                *ngIf="!prefilledFields.businessName"
                            >
                                <label class="form-label"
                                    >Business Name
                                    <span class="required-mark">*</span></label
                                >
                                <input
                                    pInputText
                                    class="w-full"
                                    placeholder="Enter your business name"
                                    formControlName="businessName"
                                    (ngModelChange)="updateSubdomain($event)"
                                />
                                <div
                                    *ngIf="
                                        businessDetailsForm.get('businessName')
                                            ?.invalid &&
                                        businessDetailsForm.get('businessName')
                                            ?.touched
                                    "
                                    class="error-message"
                                >
                                    Business name is required
                                </div>
                            </div>

                            <!-- Business Type - Only show if not pre-filled -->
                            <div
                                class="form-group"
                                *ngIf="!prefilledFields.businessType"
                            >
                                <label class="form-label"
                                    >What type of business do you have?
                                    <span class="required-mark">*</span></label
                                >
                                <p-dropdown
                                    [options]="businessTypes"
                                    formControlName="businessType"
                                    optionLabel="name"
                                    optionValue="id"
                                    placeholder="Select Business Type"
                                    styleClass="w-full"
                                >
                                </p-dropdown>
                                <div
                                    *ngIf="
                                        businessDetailsForm.get('businessType')
                                            ?.invalid &&
                                        businessDetailsForm.get('businessType')
                                            ?.touched
                                    "
                                    class="error-message"
                                >
                                    Business type is required
                                </div>
                            </div>

                            <!-- Business Description - Only show if not pre-filled -->
                            <div
                                class="form-group"
                                *ngIf="!prefilledFields.businessDescription"
                            >
                                <label class="form-label"
                                    >Tell us about your business
                                    <span class="required-mark">*</span></label
                                >
                                <textarea
                                    pInputTextarea
                                    class="w-full"
                                    rows="4"
                                    placeholder="Describe your business, products/services, and what makes you unique..."
                                    formControlName="businessDescription"
                                >
                                </textarea>
                                <div
                                    *ngIf="
                                        businessDetailsForm.get(
                                            'businessDescription'
                                        )?.invalid &&
                                        businessDetailsForm.get(
                                            'businessDescription'
                                        )?.touched
                                    "
                                    class="error-message"
                                >
                                    Business description is required
                                </div>
                            </div>

                            <!-- Street Address - Only show if not pre-filled -->
                            <div
                                class="form-group"
                                *ngIf="!prefilledFields.streetAddress"
                            >
                                <label class="form-label"
                                    >Street Address
                                    <span class="required-mark">*</span></label
                                >
                                <input
                                    pInputText
                                    class="w-full"
                                    placeholder="123 Main Street"
                                    formControlName="streetAddress"
                                />
                                <div
                                    *ngIf="
                                        businessDetailsForm.get('streetAddress')
                                            ?.invalid &&
                                        businessDetailsForm.get('streetAddress')
                                            ?.touched
                                    "
                                    class="error-message"
                                >
                                    Street address is required
                                </div>
                            </div>

                            <!-- Apartment/Suite - Only show if not pre-filled -->
                            <div
                                class="form-group"
                                *ngIf="!prefilledFields.apartment"
                            >
                                <label class="form-label"
                                    >Apartment, Suite, etc. (Optional)</label
                                >
                                <input
                                    pInputText
                                    class="w-full"
                                    placeholder="Suite 100, Apt 5B"
                                    formControlName="apartment"
                                />
                            </div>

                            <!-- Country - Only show if not pre-filled -->
                            <div
                                class="form-group"
                                *ngIf="
                                    !prefilledFields.country ||
                                    !prefilledFields.streetAddress ||
                                    !prefilledFields.city ||
                                    !prefilledFields.state ||
                                    !prefilledFields.zipCode
                                "
                            >
                                <label class="form-label"
                                    >Country
                                    <span class="required-mark">*</span></label
                                >
                                <p-dropdown
                                    [options]="countries"
                                    formControlName="country"
                                    optionLabel="name"
                                    optionValue="name"
                                    placeholder="Select Country"
                                    styleClass="w-full"
                                >
                                </p-dropdown>
                            </div>

                            <!-- Two Column Layout: City & State -->
                            <div
                                class="form-row"
                                *ngIf="
                                    !prefilledFields.city ||
                                    !prefilledFields.state
                                "
                            >
                                <div
                                    class="form-group"
                                    *ngIf="!prefilledFields.city"
                                >
                                    <label class="form-label"
                                        >City
                                        <span class="required-mark"
                                            >*</span
                                        ></label
                                    >
                                    <input
                                        pInputText
                                        class="w-full"
                                        placeholder="New York"
                                        formControlName="city"
                                    />
                                    <div
                                        *ngIf="
                                            businessDetailsForm.get('city')
                                                ?.invalid &&
                                            businessDetailsForm.get('city')
                                                ?.touched
                                        "
                                        class="error-message"
                                    >
                                        City is required
                                    </div>
                                </div>
                                <div
                                    class="form-group"
                                    *ngIf="!prefilledFields.state"
                                >
                                    <label class="form-label"
                                        >State
                                        <span class="required-mark"
                                            >*</span
                                        ></label
                                    >
                                    <p-dropdown
                                        [options]="usStates"
                                        formControlName="state"
                                        optionLabel="name"
                                        optionValue="code"
                                        placeholder="Select State"
                                        [showClear]="true"
                                        styleClass="w-full"
                                    >
                                    </p-dropdown>
                                    <div
                                        *ngIf="
                                            businessDetailsForm.get('state')
                                                ?.invalid &&
                                            businessDetailsForm.get('state')
                                                ?.touched
                                        "
                                        class="error-message"
                                    >
                                        State is required
                                    </div>
                                </div>
                            </div>

                            <!-- Zip Code - Only show if not pre-filled -->
                            <div
                                class="form-group"
                                *ngIf="!prefilledFields.zipCode"
                            >
                                <label class="form-label"
                                    >ZIP Code
                                    <span class="required-mark">*</span></label
                                >
                                <input
                                    pInputText
                                    class="w-full"
                                    placeholder="10001"
                                    formControlName="zipCode"
                                />
                                <div
                                    *ngIf="
                                        businessDetailsForm.get('zipCode')
                                            ?.invalid &&
                                        businessDetailsForm.get('zipCode')
                                            ?.touched
                                    "
                                    class="error-message"
                                >
                                    ZIP code is required
                                </div>
                            </div>

                            <!-- Phone Number - Only show if not pre-filled -->
                            <div
                                class="form-group"
                                *ngIf="!prefilledFields.businessPhone"
                            >
                                <label class="form-label"
                                    >Business Phone Number
                                    <span class="required-mark">*</span></label
                                >
                                <input
                                    pInputText
                                    class="w-full"
                                    placeholder="(555) 123-4567"
                                    formControlName="businessPhone"
                                    (input)="onPhoneInput($event)"
                                />
                                <div
                                    *ngIf="
                                        businessDetailsForm.get('businessPhone')
                                            ?.invalid &&
                                        businessDetailsForm.get('businessPhone')
                                            ?.touched
                                    "
                                    class="error-message"
                                >
                                    Business phone number is required
                                </div>
                            </div>
                        </form>

                        <div class="actions">
                            <p-button
                                [label]="isStepCompleted(1) ? 'Save Changes' : 'Save and Continue'"
                                styleClass="p-button-primary w-full"
                                (onClick)="validateAndCompleteStep(1)"
                            >
                            </p-button>
                            <!-- <a class="skip-btn" (click)="skipStep(1)">Skip for now</a> -->
                        </div>
                    </div>
                </p-accordionTab>
                <!-- STEP 2: Design your store -->
                <p-accordionTab *ngIf="showDesignStore">
                    <ng-template pTemplate="header">
                        <div class="step-header-content">
                            <div class="step-left">
                                <div
                                    class="icon-box"
                                    [class.completed]="isStepCompleted(2)"
                                >
                                    <!-- <span *ngIf="!isStepCompleted(2)">2</span> -->
                                    <i
                                        *ngIf="isStepCompleted(2)"
                                        class="pi pi-check"
                                        style="
                                            font-size: 12px;
                                            font-weight: bold;
                                        "
                                    ></i>
                                </div>
                                <span
                                    class="step-text"
                                    [class.text-completed]="isStepCompleted(2)"
                                    >Choose Store Layout</span
                                >
                            </div>
                        </div>
                    </ng-template>
                    <div class="step-content-inner">
                        <!-- Step 2 Helper Text -->
                        <p class="helper-text">Choose your store layout.</p>

                        <!-- Show summary if step 2 is completed -->
                        <div *ngIf="isStepCompleted(2)" class="summary-box">
                            <div class="summary-content">
                                <div class="completion-message">
                                    <i
                                        class="pi pi-check-circle"
                                        style="
                                            font-size: 24px;
                                            color: #28a745;
                                            margin-bottom: 12px;
                                        "
                                    ></i>
                                    <h4 style="margin: 8px 0; color: #155724">
                                        Layout Configuration Complete
                                    </h4>
                                    <p
                                        style="
                                            margin: 0;
                                            color: #666;
                                            font-size: 14px;
                                        "
                                    >
                                        Your store layout has been successfully
                                        configured.
                                    </p>
                                    <p
                                        style="
                                            margin: 4px 0 0 0;
                                            color: #666;
                                            font-size: 14px;
                                        "
                                    >
                                        You can now proceed to the next step.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Show form if step 2 is NOT completed -->
                        <form
                            [formGroup]="designStoreForm"
                            *ngIf="!isStepCompleted(2)"
                        >
                            <!-- Store URL -->
                            <div class="form-group">
                                <label class="form-label"
                                    >Store URL
                                    <span class="required-mark">*</span></label
                                >
                                <div class="subdomain-preview">
                                    <div class="subdomain-info">
                                        <div class="subdomain-input-group">
                                            <input
                                                pInputText
                                                class="subdomain-input"
                                                placeholder="Store URL"
                                                formControlName="subdomain"
                                            />
                                            <span class="subdomain-extension"
                                                >.lincsell.com</span
                                            >
                                        </div>
                                        <!-- Availability Check Status -->
                                        <div
                                            *ngIf="subdomainCheckLoading"
                                            class="availability-status loading"
                                        >
                                            <i
                                                class="pi pi-spinner pi-spin"
                                                style="margin-right: 8px"
                                            ></i>
                                            <span
                                                >Checking availability...</span
                                            >
                                        </div>
                                        <div
                                            *ngIf="
                                                !subdomainCheckLoading &&
                                                subdomainAvailable === true
                                            "
                                            class="availability-status available"
                                        >
                                            <i
                                                class="pi pi-check-circle"
                                                style="
                                                    margin-right: 8px;
                                                    color: #28a745;
                                                "
                                            ></i>
                                            <span style="color: #28a745"
                                                >This store name is
                                                available!</span
                                            >
                                        </div>
                                        <div
                                            *ngIf="
                                                !subdomainCheckLoading &&
                                                subdomainAvailable === false
                                            "
                                            class="availability-status unavailable"
                                        >
                                            <i
                                                class="pi pi-times-circle"
                                                style="
                                                    margin-right: 8px;
                                                    color: #dc3545;
                                                "
                                            ></i>
                                            <span style="color: #dc3545">{{
                                                subdomainCheckError
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    *ngIf="
                                        designStoreForm.get('subdomain')
                                            ?.invalid &&
                                        designStoreForm.get('subdomain')
                                            ?.touched
                                    "
                                    class="error-message"
                                >
                                    Valid subdomain is required
                                </div>
                            </div>

                            <!-- Business Logo Upload - HIDDEN -->
                            <!-- <div class="form-group">
                <label class="form-label">Business Logo</label>
                <p class="helper-text-small">Recommended size: 200x200px or larger. Supported formats: JPG, PNG, GIF. Maximum file size: 5MB.</p>
                <div *ngIf="!logoPreview" class="upload-btn-wrapper">
                  <button class="btn-upload" (click)="logoFileInput.click()">
                    <i class="pi pi-upload" style="margin-right: 5px"></i> Upload Logo
                  </button>
                  <input #logoFileInput type="file" accept="image/*" (change)="handleLogoUpload($event)" style="display:none">
                </div>
                <div *ngIf="logoPreview" class="img-preview-container">
                  <img [src]="logoPreview" alt="Logo Preview" class="img-preview">
                  <button class="btn-remove-img" (click)="removeLogo()">✕</button>
                </div>
              </div> -->

                            <!-- Theme Selection -->
                            <div class="form-group">
                                <label class="form-label"
                                    >Select a Layout Theme
                                    <span class="required-mark">*</span></label
                                >
                                <div class="theme-grid">
                                    <div
                                        class="theme-card"
                                        *ngFor="let theme of themeList"
                                        [class.selected]="
                                            selectedTheme?.templateID ===
                                            theme.templateID
                                        "
                                        (click)="requestThemeSelection(theme)"
                                    >
                                        <div
                                            class="theme-preview"
                                            [ngClass]="
                                                getTemplatePreviewClass(theme)
                                            "
                                        >
                                            <img
                                                [src]="getThemePreviewImage(theme)"
                                                alt="{{ theme.name }} Preview"
                                                class="theme-image"
                                                loading="lazy"
                                                referrerpolicy="no-referrer"
                                                (error)="onThemePreviewError($event)"
                                            />
                                        </div>
                                        <div class="theme-info">
                                            <span class="theme-name">{{
                                                theme.name ?? ""
                                            }}</span>

                                            <a
                                                class="theme-demo-link"
                                                [href]="theme.demoUrl"
                                                target="_blank"
                                                rel="noopener"
                                                (click)="$event.stopPropagation()"
                                                >View Demo &rarr;</a
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="actions">
                            <p-button
                                *ngIf="!isStepCompleted(2)"
                                label="Save and Continue"
                                styleClass="p-button-primary w-full"
                                (onClick)="validateAndCompleteStep(2)"
                            ></p-button>
                            <p-button
                                *ngIf="isStepCompleted(2)"
                                label="Next Step"
                                styleClass="p-button-primary w-full"
                                (onClick)="skipStep(2)"
                            ></p-button>
                            <!-- <a class="skip-btn" (click)="skipStep(2)">Skip for now</a> -->
                        </div>
                    </div>
                </p-accordionTab>
                <!-- STEP 3: Add Products -->
                <p-accordionTab *ngIf="showAddProducts">
                    <ng-template pTemplate="header">
                        <div class="step-header-content">
                            <div class="step-left">
                                <div
                                    class="icon-box"
                                    [class.completed]="isStepCompleted(3)"
                                >
                                    <!-- <span *ngIf="!isStepCompleted(3)">3</span> -->
                                    <i
                                        *ngIf="isStepCompleted(3)"
                                        class="pi pi-check"
                                        style="
                                            font-size: 12px;
                                            font-weight: bold;
                                        "
                                    ></i>
                                </div>
                                <span
                                    class="step-text"
                                    [class.text-completed]="isStepCompleted(3)"
                                    >Add Products</span
                                >
                            </div>
                        </div>
                    </ng-template>
                    <div class="step-content-inner">
                        <!-- Show product summary if step 3 is completed and NOT adding another product -->
                        <div
                            *ngIf="
                                isStepCompleted(3) && !isAddingAnotherProduct
                            "
                            class="product-summary"
                        >
                            <div class="summary-box">
                                <h4 class="summary-title">
                                    You have
                                    <strong>{{ productCount }}</strong>
                                    product{{
                                        productCount !== 1 ? "s" : ""
                                    }}
                                    added
                                </h4>
                                <p class="summary-text">
                                    Great! You've successfully added products to
                                    your store.
                                </p>
                                <div class="summary-actions">
                                    <p-button
                                        label="+ Add Another Product"
                                        styleClass="p-button-outlined w-full"
                                        (onClick)="addAnotherProduct()"
                                    ></p-button>
                                </div>
                            </div>
                        </div>
                        <!-- Show product form if step 3 is not completed OR adding another product -->
                        <div
                            *ngIf="
                                !isStepCompleted(3) || isAddingAnotherProduct
                            "
                        >
                            <form [formGroup]="addProductsForm">
                                <div class="form-group">
                                    <label class="form-label"
                                        >Product Name
                                        <span class="required-mark"
                                            >*</span
                                        ></label
                                    >
                                    <input
                                        type="text"
                                        pInputText
                                        class="w-full"
                                        placeholder="e.g. Summer T-Shirt"
                                        formControlName="productName"
                                    />
                                    <div
                                        *ngIf="
                                            addProductsForm.get('productName')
                                                ?.invalid &&
                                            addProductsForm.get('productName')
                                                ?.touched
                                        "
                                        class="error-message"
                                    >
                                        Product name is required
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="form-label"
                                        >Category
                                        <span class="required-mark"
                                            >*</span
                                        ></label
                                    >
                                    <input
                                        type="text"
                                        pInputText
                                        class="w-full"
                                        placeholder="e.g. Clothing"
                                        formControlName="productCategory"
                                    />
                                    <div
                                        *ngIf="
                                            addProductsForm.get(
                                                'productCategory'
                                            )?.invalid &&
                                            addProductsForm.get(
                                                'productCategory'
                                            )?.touched
                                        "
                                        class="error-message"
                                    >
                                        Category is required
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="form-label"
                                        >Description
                                        <span class="required-mark"
                                            >*</span
                                        ></label
                                    >
                                    <textarea
                                        pInputTextarea
                                        class="w-full"
                                        rows="3"
                                        placeholder="Describe your product..."
                                        formControlName="productDescription"
                                    ></textarea>
                                    <div
                                        *ngIf="
                                            addProductsForm.get(
                                                'productDescription'
                                            )?.invalid &&
                                            addProductsForm.get(
                                                'productDescription'
                                            )?.touched
                                        "
                                        class="error-message"
                                    >
                                        Description is required
                                    </div>
                                </div>
                                <div class="">
                                    <div class="form-group">
                                        <label class="form-label"
                                            >Price ($)
                                            <span class="required-mark"
                                                >*</span
                                            ></label
                                        >
                                        <p-inputNumber
                                            mode="currency"
                                            currency="USD"
                                            locale="en-US"
                                            placeholder="0.00"
                                            formControlName="productPrice"
                                            styleClass="w-full"
                                            class="w-full"
                                        ></p-inputNumber>
                                        <div
                                            *ngIf="
                                                addProductsForm.get(
                                                    'productPrice'
                                                )?.invalid &&
                                                addProductsForm.get(
                                                    'productPrice'
                                                )?.touched
                                            "
                                            class="error-message"
                                        >
                                            Price must be greater than 0
                                        </div>
                                    </div>
                                    <!-- Custom Image Upload Logic -->
                                    <div class="form-group">
                                        <label class="form-label"
                                            >Product Image</label
                                        >
                                        <p class="helper-text-small">
                                            Recommended size: 1:1 (500x500). Supported formats: JPG, PNG,
                                            GIF, BMP, SVG, AVIF. Maximum file size: 5MB.
                                        </p>
                                        <div
                                            *ngIf="!imgPreview"
                                            class="upload-btn-wrapper"
                                        >
                                            <button
                                                class="btn-upload"
                                                (click)="fileInput.click()"
                                            >
                                                <i
                                                    class="pi pi-upload"
                                                    style="margin-right: 5px"
                                                ></i>
                                                Upload Image
                                            </button>
                                            <input
                                                #fileInput
                                                type="file"
                                                 accept=".png,.jpg,.jpeg,.webp,.gif,.bmp,.svg,.avif"
                                                (change)="
                                                    handleImageUpload($event)
                                                "
                                                style="display: none"
                                            />
                                        </div>
                                        <div
                                            *ngIf="imgPreview"
                                            class="img-preview-container"
                                        >
                                            <img
                                                [src]="imgPreview"
                                                alt="Preview"
                                                class="img-preview"
                                            />
                                            <button
                                                class="btn-remove-img"
                                                (click)="removeImage()"
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div class="actions">
                                <p-button
                                    label="Save Product and Continue"
                                    styleClass="p-button-primary w-full"
                                    (onClick)="completeStep(3)"
                                ></p-button>
                                <a
                                    class="skip-btn"
                                    *ngIf="isOnlyAddProductsRemaining()"
                                    (click)="skipStep(3)"
                                    >Skip for now</a
                                >
                            </div>
                        </div>
                    </div>
                </p-accordionTab>
                <!-- STEP 4: Payment -->
                <p-accordionTab *ngIf="showPaymentProvider">
                    <ng-template pTemplate="header">
                        <div class="step-header-content">
                            <div class="step-left">
                                <div
                                    class="icon-box"
                                    [class.completed]="isStepCompleted(4)"
                                >
                                    <!-- <span *ngIf="!isStepCompleted(4)">4</span> -->
                                    <i
                                        *ngIf="isStepCompleted(4)"
                                        class="pi pi-check"
                                        style="
                                            font-size: 12px;
                                            font-weight: bold;
                                        "
                                    ></i>
                                </div>
                                <span
                                    class="step-text"
                                    [class.text-completed]="isStepCompleted(4)"
                                    >Connect Payment Provider</span
                                >
                            </div>
                        </div>
                    </ng-template>
                    <div class="step-content-inner">
                        <!-- Step 4 Helper Text -->
                        <p class="helper-text mb-4">
                            Connect your Stripe account to accept secure online
                            payments from your customers. Stripe handles credit
                            cards, debit cards, and digital payments securely.
                        </p>
                        <div class="actions">
                            <p-button
                                label="Connect Stripe"
                                styleClass="stripe-btn w-full"
                                (onClick)="openConnectStripeAccount()"
                            ></p-button>
                            <!-- <a class="skip-btn" (click)="skipStep(4)">Skip for now</a> -->
                        </div>
                    </div>
                </p-accordionTab>
                <!-- STEP 5: Shipping
        <p-accordionTab 
          (onOpen)="onShippingStepOpen()">
          <ng-template pTemplate="header">
            <div class="step-header-content">
              <div class="step-left">
                <div class="icon-box" [class.completed]="isStepCompleted(5)">
                  <i *ngIf="isStepCompleted(5)" class="pi pi-check" style="font-size: 12px; font-weight: bold;"></i>
                </div>
                <span class="step-text" [class.text-completed]="isStepCompleted(5)">Shipping Settings</span>
              </div>
            </div>
          </ng-template>
          <div class="step-content-inner">
            <p class="helper-text">Set up basic shipping options here. For detailed shipping settings including zones, rates, and carriers, visit the <a href="/#/app/business?page=shipping" class="info-link">Shipping Settings</a> section.</p>
            
            <app-basic-shipping 
              #basicShippingComponent
              [currency]="'USD'"
              (formSubmitted)="completeStep(5)"
              (formChanged)="onShippingFormChanged($event)">
            </app-basic-shipping>
          </div>
        </p-accordionTab> -->
                <!-- STEP 6: Preview -->
                <p-accordionTab *ngIf="showPreviewStore">
                    <ng-template pTemplate="header">
                        <div class="step-header-content">
                            <div class="step-left">
                                <div
                                    class="icon-box"
                                    [class.completed]="isStepCompleted(6)"
                                >
                                    <!-- <span *ngIf="!isStepCompleted(6)">6</span> -->
                                    <i
                                        *ngIf="isStepCompleted(6)"
                                        class="pi pi-check"
                                        style="
                                            font-size: 12px;
                                            font-weight: bold;
                                        "
                                    ></i>
                                </div>
                                <span
                                    class="step-text"
                                    [class.text-completed]="isStepCompleted(6)"
                                    >View Your Store</span
                                >
                            </div>
                        </div>
                    </ng-template>
                    <div class="step-content-inner">
                        <div
                            *ngIf="!isStepCompleted(1) || !isStepCompleted(3)"
                            class="alert-box"
                        >
                            <i
                                class="pi pi-info-circle"
                                style="margin-right: 10px; font-size: 18px"
                            ></i>
                            <div>
                                <p style="margin: 0; font-weight: 600">
                                    Complete Required Steps
                                </p>
                                <p style="margin: 5px 0 0 0; font-size: 0.9rem">
                                    To view your store preview, please complete:
                                    <!-- <span *ngIf="!isStepCompleted(1)" style="display: block; margin-top: 5px;">• Step 1: Business Details</span> -->
                                    <!-- <span *ngIf="!isStepCompleted(3)" style="display: block; margin-top: 5px;">• Step 3: Add Products</span> -->
                                </p>
                            </div>
                        </div>
                        <p
                            class="helper-text mb-4"
                            *ngIf="isStepCompleted(1) && isStepCompleted(3)"
                        >
                            Your store is ready. Preview it now to see how it
                            looks to your customers.
                        </p>
                        <div
                            class="actions"
                            *ngIf="isStepCompleted(1) && isStepCompleted(3)"
                        >
                            <p-button
                                label="Preview Store"
                                styleClass="w-full"
                                (onClick)="completeStep(6)"
                            ></p-button>
                        </div>
                    </div>
                </p-accordionTab>
            </p-accordion>
        </div>
        <!-- SUCCESS VIEW -->
        <div *ngIf="isSuccess" class="success-view">
            <div class="checkmark-circle">
                <i
                    class="pi pi-check"
                    style="font-size: 32px; font-weight: bold"
                ></i>
            </div>
            <h2>You are all set</h2>
            <p>Your store is configured and ready.</p>
            <div class="actions mt-4">
                <!-- <div style="margin-bottom: 12px;">
          <p-button label="Edit Online Store" styleClass="p-button-outlined w-full" (onClick)="goToEditer()"></p-button>
        </div> -->
                <p-button
                    label="Explore Dashboard"
                    styleClass="p-button-primary w-full mt-2"
                    (onClick)="goToDashboard()"
                >
                </p-button>
            </div>
            <p *ngIf="isCountingDown" class="text-center text-muted mt-3">
                Redirecting to dashboard in {{ redirectCountdown }} seconds...
            </p>
        </div>
    </div>
    <!-- FOOTER -->
    <!-- <div class="footer-skip">
    <a href="#">Go to dashboard &rarr;</a>
  </div> -->
    <!-- Layout Confirmation Dialog -->
    <p-dialog
        [(visible)]="showLayoutConfirmDialog"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [closable]="false"
        [dismissableMask]="true"
        [style]="{ width: '560px', maxWidth: '92vw' }"
        styleClass="layout-confirm-dialog"
    >
        <div class="layout-confirm-content">
            <p>
                Please choose your template carefully, as it will be used to
                setup your online store and cannot be changed once selected.
            </p>
            <div class="layout-confirm-actions">
                <button
                    type="button"
                    class="inventory-mode-btn"
                    (click)="dismissLayoutConfirmation()"
                >
                    Discard
                </button>
                <button
                    type="button"
                    class="inventory-mode-btn active"
                    (click)="confirmLayoutSelection()"
                >
                    Continue
                </button>
            </div>
        </div>
    </p-dialog>
</div>
